import { Drawer, Menu, Popover } from "antd";
import { Link } from "react-router-dom";
import DocUpdateIcon from "../../assets/DocUpdateIcon.svg";
import { DownOutlined } from "@ant-design/icons";
import { useSideBarMenu } from "../../utils/content/sidebar-menus";
import "./WPHeader.css";

const WPHeader = () => {
  const { NAVBAR_INFO_MOBILE, POPUP_CONTENT, open, setOpen } =
    useSideBarMenu();

  return (
    <>
      {/* ===== Desktop Header (floating pill) ===== */}
      <header className="wp-header">
        <div className="wp-header__inner">
          <div className="wp-header__left">
            <a
              href="https://www.docupdate.io/"
              className="wp-header__logo"
              aria-label="DocUpdate Home"
            >
              <img
                src={DocUpdateIcon}
                alt="DocUpdate"
                className="wp-header__logo-img"
              />
            </a>
            <nav className="wp-header__nav" aria-label="Primary">
              <Popover
                placement="bottomLeft"
                title={""}
                content={POPUP_CONTENT}
                overlayClassName="wp-header__popover"
                arrow={false}
                getPopupContainer={() => document.body}
                trigger={["hover", "click"]}
              >
                <a
                  href="#"
                  className="wp-header__nav-link"
                  onClick={(e) => e.preventDefault()}
                >
                  Our Tools
                  <DownOutlined className="wp-header__chevron" />
                </a>
              </Popover>
              <a
                href="https://www.docupdate.io/articles/"
                className="wp-header__nav-link"
              >
                Articles
              </a>
              <a
                href="https://www.docupdate.io/about-us/"
                className="wp-header__nav-link"
              >
                About Us
              </a>
              <a
                href="https://www.docupdate.io/manage-preferences/"
                className="wp-header__nav-link"
              >
                Manage Preferences
              </a>
            </nav>
          </div>
          <div className="wp-header__right">
            <Link to={"/signup-new"} className="wp-header__btn-outline">
              Sign Up
            </Link>
            <a
              href="https://docupdate.onelink.me/j4xR/desktop"
              className="wp-header__btn-solid"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get the App
            </a>
          </div>
        </div>
      </header>

      {/* ===== Mobile Header ===== */}
      <header className="wp-header-mobile">
        <div className="wp-header-mobile__inner">
          <a
            href="https://www.docupdate.io/"
            className="wp-header__logo"
            aria-label="DocUpdate Home"
          >
            <img
              src={DocUpdateIcon}
              alt="DocUpdate"
              className="wp-header__logo-img wp-header__logo-img--mobile"
            />
          </a>
          <button
            onClick={() => setOpen((prev) => !prev)}
            className="wp-header-mobile__menu-btn"
            aria-label="Open menu"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </header>

      {/* ===== Mobile Drawer ===== */}
      <Drawer
        placement="right"
        closable={true}
        onClose={() => setOpen(false)}
        open={open}
        destroyOnClose
        className="navbar_drawer flex justify-center p-[0.85rem_1.5rem] w-full"
      >
        <div className="wp-drawer__content">
          <Menu
            mode="inline"
            className="w-full h-full border-none flex flex-col gap-y-4 max-h-[360px]"
            items={NAVBAR_INFO_MOBILE}
            defaultSelectedKeys={["1"]}
          />
          <div className="wp-drawer__buttons">
            <Link to={"/signup-new"} className="wp-drawer__btn-outline">
              Sign Up
            </Link>
            <a
              href="https://docupdate.onelink.me/j4xR/desktop"
              className="wp-drawer__btn-solid"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get the App
            </a>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default WPHeader;